/**
 * Cart / product price display (formerly bundled in filter-menu.js).
 * Fills empty .item_price / .item_total_price spans and applies trade discounts + Bold option prices.
 */
var _cartSubTotal = 0;
var _cartItemSubTotal = [];

var splitAndTotal = function(quantity, _string){
  _string = _string.split(',');

  var num = 0;

  for(var n=0; n<_string.length; n++) {
    num += Number(_string[n]);
  }

  return quantity ? (num * quantity) : num;
};

var _formatCartMoney = function(cents) {
  if (window.BOLD && window.BOLD.common && window.BOLD.common.Shopify && typeof window.BOLD.common.Shopify.formatMoney === 'function') {
    return window.BOLD.common.Shopify.formatMoney(cents, window.BOLD.common.Shopify.shop.money_format);
  }
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, window.money_format);
  }
  return cents;
};

var _itemLoop = function(_items){
  if (!_items || !_items.length) {
    return;
  }

  var totalRow = document.querySelectorAll('.cart__row.table__section');

  for(var i=0; i<_items.length; i++) {
    var item = _items[i];
    var row = totalRow[i];

    //as we integrated default checkout flow form tradeprogram users PD-261
    if(typeof searchCustomerTags !== 'undefined' && $.inArray('tradeprogram', searchCustomerTags) > -1) {
      var linePrice = item.price;
    } else {
      var linePrice = item.final_price;
    }

    var rowItemPrice = Number(linePrice);
    var rowToltaPrice = rowItemPrice * item.quantity;
    var boldVPrice = item.properties && item.properties._boldVariantPrices ? item.properties._boldVariantPrices.split(',') : 0;
    var boldVQtys = item.properties && item.properties._boldVariantQtys ? item.properties._boldVariantQtys.split(',') : 0;
    var discount = row && row.getAttribute('data-discount') ? Number(row.getAttribute('data-discount')) : 0;
    var boldItemPrice = 0;
  	var boldTotalPrice = 0;
    var allProperties = item.properties;

    var _boldVariantPricesNew = '';
  	var _boldVariantQtysNew = '';

    if(boldVQtys) {
      for(var k=0; k<boldVQtys.length; k++) {
        var qt = boldVQtys[k].indexOf('*') === -1 ? item.quantity : parseInt(boldVQtys[k]);

        boldItemPrice += 1 * Number(boldVPrice[k]);
        boldTotalPrice += qt * Number(boldVPrice[k]);

        _boldVariantPricesNew += (_boldVariantPricesNew ? ',' : '') + boldVPrice[k];
      	_boldVariantQtysNew += (_boldVariantQtysNew ? ',' : '') + (boldVQtys[k].indexOf('*') === -1 ? qt : (qt + '*'));
      }

      if(item.properties && _boldVariantQtysNew !== item.properties._boldVariantQtys) {
        allProperties._boldVariantQtys = _boldVariantQtysNew;

        jQuery.post('/cart/change.js', {
          line: (i + 1),
          quantity: item.quantity,
          properties: allProperties
        });
      }

    } else if(boldVPrice && boldVPrice.length) {
      for(var k = 0; k < boldVPrice.length; k++) {
        boldItemPrice += 1 * Number(boldVPrice[k]);
        boldTotalPrice += item.quantity * Number(boldVPrice[k]);
      }
    }

    rowItemPrice = rowItemPrice + boldItemPrice;
    rowItemPrice = ((rowItemPrice - (rowItemPrice * discount))/100)*100;

    rowToltaPrice = rowToltaPrice + boldTotalPrice;
    rowToltaPrice = ((rowToltaPrice - (rowToltaPrice * discount))/100)*100;

    _cartSubTotal += rowToltaPrice;
    _cartItemSubTotal[item.key] = rowToltaPrice;

    if(row) {
      var item_price = row.querySelectorAll('.item_price')[0];
      var item_strike_price = row.querySelectorAll('.item_strike_price')[0];
      var item_total_price = row.querySelectorAll('.item_total_price')[0];

      if(item_price) {
        item_price.innerHTML = _formatCartMoney(rowItemPrice);
      }

      if(item_strike_price) {
        item_strike_price.innerHTML = _formatCartMoney((linePrice + boldItemPrice));
      }

      if(item_total_price) {
        item_total_price.innerHTML = _formatCartMoney(rowToltaPrice);
      }
    }

  }
};

document.addEventListener('DOMContentLoaded', function(){
  if (window.boldCart && window.boldCart.items) {
    _itemLoop(window.boldCart.items);
    $('.price-span-total, .cart-subtotal').html(Shopify.formatMoney(_cartSubTotal, window.money_format));
    if (typeof window.updateNegotiatedFreightFromSubtotal === 'function' && window.negotiatedFreightRate) {
      window.updateNegotiatedFreightFromSubtotal(window.negotiatedFreightRate);
    }
  }
}, false);

function loadOroginalLogo(ele) {
  var url = $(ele).data('logo');
  $(ele).closest('a').css('background-image', 'url("' + url + '")').addClass('cls-default-logo');
}

$(document).ready(function() {
  var src = $('.site-header-opacity .hidden-logo').attr('src');
  if (src) {
    $('.site-header-opacity .hidden-logo').attr('src', src);
  }
});

$('.bold_option_price_display').on('change.price', function(e, format) {
  var next_price_span = $(this).next("#ProductPrice");
  var priceParts = ($(this).text() || '').split('(');
  var basePrice = Number(priceParts[0].replace(/[^0-9.]/gi, '')) || 0;
  var extraPrice = priceParts[1] ? (Number(priceParts[1].replace(/[^0-9.]/gi, '')) || 0) : 0;
  var price = basePrice + extraPrice;

  if(next_price_span.length) {
    var discountPercentage = next_price_span.attr("data-discount");
    discountPercentage = Number(discountPercentage);
    price = Number(price);
    if(discountPercentage >= 0 && price >= 0 ) {
      price = price * 100;
      var discountPrice = ((price - (price * discountPercentage))/100)*100;
      next_price_span.html(Shopify.formatMoney(discountPrice, format));
    }
  }
});
